export const moreInfo = {
    title: "Ouvrir le panneau contextuel",
    more: "Plus d'infos",
    less: "Moins d'infos"
}